import React from 'react';
import Cognito from '@letsdothis/cognito';
import {
  AuthProviderButton,
  PROVIDER,
} from '@letsdothis/lds/lib/experimental/AuthProviderButton';
import { CONTENT_MODE } from '@letsdothis/lds/lib/Button';

import { useAuthService } from '@/contexts/authService';

import { ButtonLayout } from './ButtonLayout';
import { FacebookButtonParams } from './Types';

const FacebookButton = ({ returnUrl }: FacebookButtonParams): JSX.Element => {
  const authService = useAuthService();
  return (
    <ButtonLayout>
      <AuthProviderButton
        provider={PROVIDER.facebook}
        contentMode={CONTENT_MODE.fullWidth}
        onClick={() =>
          authService.login({
            provider: Cognito.IdentityProvider.FACEBOOK,
            returnUrl,
          })
        }
      >
        Sign in with Facebook
      </AuthProviderButton>
    </ButtonLayout>
  );
};

export default FacebookButton;
